'use client';

import type { CheckoutLifecycleEvent } from './CheckoutLifecycleEvent';
import { useOnCheckoutLifecycle } from './useOnCheckoutLifecycle';

/**
 * Subscribe to checkout COMPLETIONS — used by gated surfaces (a paywalled post, a
 * tier-locked clip) that stay mounted under the soft checkout overlay and must
 * react when their purchase lands. See {@link useOnCheckoutLifecycle} for the
 * stability contract and no-provider behavior.
 */
export function useOnCheckoutSuccess(
  listener: (event: CheckoutLifecycleEvent) => void,
): void {
  useOnCheckoutLifecycle('success', listener);
}
